import React, { useEffect ,} from 'react';
import { useParams } from 'react-router-dom';
import List from 'src/components/grid.component';
import AddressCell from 'src/utils/addressCell';

const BankDetails = () => {
  let { custId } = useParams();
  const [copiedState, setCopiedState] = React.useState('');
  const apiurl = `${process.env.REACT_APP_API_END_POINT_CARD}/api/v1/ExchangeWallet/BankAccounts/${custId}/All`;
  const gridRef = React.createRef();
  const handlestateCopy =(id) =>{
    setCopiedState(id);
    setTimeout(() => {
      setCopiedState('');
    }, 300)
  }
  
  useEffect(() => {
    gridRef.current?.refreshGrid();
  }, [])
  const customcells = {
    "customerName": (RenderProps) => (<td><div><button className='gridLink c-pointer batch-filename px-0' onClick={() => navigate(`/customer/${RenderProps?.dataItem?.customerId}/Bank`)}>{(RenderProps?.dataItem?.customerName)}</button></div></td>),
    "balance": (RenderProps) => (
      <td>
        {RenderProps?.dataItem?.balance != null
          ? parseFloat(RenderProps?.dataItem?.balance).toLocaleString(undefined, { maximumFractionDigits: 20 })
          : ''}
      </td>
    ), "accountIbanNumber": (cellProps) => (
      <AddressCell
        id={cellProps?.dataItem?.accountIbanNumber}
        address={cellProps?.dataItem?.accountIbanNumber}
        copied={copiedState}
        handleCopy={handlestateCopy}
        IbanNumber={cellProps?.dataItem?.accountIbanNumber}
      />
    ),
    "swiftBicCode": (cellProps) => (
      <AddressCell
        id={cellProps?.dataItem?.swiftBicCode}
        address={cellProps?.dataItem?.swiftBicCode}
        copied={copiedState}
        handleCopy={handlestateCopy}
        swfitcode={cellProps?.dataItem?.swiftBicCode}
      />
    ),
  }
  const renderCustomCell = (prop, column) => {
    if (customcells[column.field])
      return customcells[column.field](prop);
  }
  return (
    <div>
      <List
        showExcelExport={true}
        url={apiurl}
        ref={gridRef}
        pSize={10}
        screenName={"Customers_Bank"}
        className="custom-grid card-historylist"
        renderCustomCell={renderCustomCell}
        hasFooter={true}
      />
    </div>
  )
}

export default BankDetails